export enum ContainerAttributes {
  IsHeader = 'isHeader',
  IsSubComponent = 'isContainerSubComponent',
  IsSubComponentArrow = 'isSubComponentArrow',
  IsSubComponentUpArrow = 'isSubComponentUpArrow',
  IsSubComponentDownArrow = 'isSubComponentDownArrow',
  HasHeader = 'hasHeader',
  IsSelectionBehavior = 'isContainerSelectionBehavior',
  HasSubAction = 'hasSubAction',
}
